// extracted by mini-css-extract-plugin
export default {"nav":"TabNavVertical_nav__--tuU","btn":"TabNavVertical_btn__9gxRI","active":"TabNavVertical_active__+JSZa","icon":"TabNavVertical_icon__3InZv"};